// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from SmsForm.module.scss  */
.SmsForm-module-Root_6LR {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  height: calc(100vh - 32px);
  padding-top: 62px;
  /* half height of .Addons */
  padding-bottom: 56px; }
  .SmsForm-module-Root_6LR div {
    box-sizing: border-box; }

.SmsForm-module-Header_2gE {
  margin-bottom: 57px;
  text-align: center; }
  .SmsForm-module-Header_2gE a,
  .SmsForm-module-Header_2gE button {
    display: inline-block; }

.SmsForm-module-Headline_7ca {
  font-family: var(--display-font-family);
  font-size: 1.375rem;
  font-weight: 600;
  line-height: 1.25;
  color: var(--smsform-headline-color); }
  .SmsForm-module-Headline_7ca + div,
  .SmsForm-module-Headline_7ca + a,
  .SmsForm-module-Headline_7ca + button {
    margin-top: 8px; }

.SmsForm-module-Description_1ET {
  font-family: var(--control-font-family);
  font-size: 1rem;
  line-height: 1.25;
  color: var(--smsform-description-color); }

.SmsForm-module-Footer_2ZP {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-bottom: 18px;
  text-align: center; }

.SmsForm-module-Error_3I1 {
  width: 100%;
  font-family: var(--control-font-family);
  font-size: 0.875rem;
  line-height: 1.25;
  text-align: center;
  color: var(--smsform-error-color); }

.SmsForm-module-Addons_U-3 {
  position: relative;
  width: 100%;
  height: 124px;
  padding-top: 24px;
  text-align: center; }

.SmsForm-module-Preloader_30w {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  will-change: transform; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/SmsForm/SmsForm.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,0BAA0B;EAC1B,iBAAiB;EACjB,2BAA2B;EAC3B,oBAAoB,EAAE;EACtB;IACE,sBAAsB,EAAE;;AAE5B;EACE,mBAAmB;EACnB,kBAAkB,EAAE;EACpB;;IAEE,qBAAqB,EAAE;;AAE3B;EACE,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC,EAAE;EACtC;;;IAGE,eAAe,EAAE;;AAErB;EACE,uCAAuC;EACvC,eAAe;EACf,iBAAiB;EACjB,uCAAuC,EAAE;;AAE3C;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,oBAAoB;EACpB,kBAAkB,EAAE;;AAEtB;EACE,WAAW;EACX,uCAAuC;EACvC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC,EAAE;;AAErC;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB,EAAE;;AAEtB;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,sBAAsB,EAAE","sourcesContent":["/*  imported from SmsForm.module.scss  */\n.SmsForm-module-Root_6LR {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n  height: calc(100vh - 32px);\n  padding-top: 62px;\n  /* half height of .Addons */\n  padding-bottom: 56px; }\n  .SmsForm-module-Root_6LR div {\n    box-sizing: border-box; }\n\n.SmsForm-module-Header_2gE {\n  margin-bottom: 57px;\n  text-align: center; }\n  .SmsForm-module-Header_2gE a,\n  .SmsForm-module-Header_2gE button {\n    display: inline-block; }\n\n.SmsForm-module-Headline_7ca {\n  font-family: var(--display-font-family);\n  font-size: 1.375rem;\n  font-weight: 600;\n  line-height: 1.25;\n  color: var(--smsform-headline-color); }\n  .SmsForm-module-Headline_7ca + div,\n  .SmsForm-module-Headline_7ca + a,\n  .SmsForm-module-Headline_7ca + button {\n    margin-top: 8px; }\n\n.SmsForm-module-Description_1ET {\n  font-family: var(--control-font-family);\n  font-size: 1rem;\n  line-height: 1.25;\n  color: var(--smsform-description-color); }\n\n.SmsForm-module-Footer_2ZP {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding-bottom: 18px;\n  text-align: center; }\n\n.SmsForm-module-Error_3I1 {\n  width: 100%;\n  font-family: var(--control-font-family);\n  font-size: 0.875rem;\n  line-height: 1.25;\n  text-align: center;\n  color: var(--smsform-error-color); }\n\n.SmsForm-module-Addons_U-3 {\n  position: relative;\n  width: 100%;\n  height: 124px;\n  padding-top: 24px;\n  text-align: center; }\n\n.SmsForm-module-Preloader_30w {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  will-change: transform; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
